import downloadFile from './download-file';

const downloadFileFromTrpc = (
  {
    mimeType,
    name,
    content,
  }: {
    mimeType: string;
    name: string;
    content: string;
  },
  onEmpty?: () => void,
) => {
  if ((!content || !mimeType) && onEmpty) {
    onEmpty();
    return;
  }
  const uint8 = Uint8Array.from(atob(content), (c) => c.charCodeAt(0));
  const blob = new Blob([uint8], { type: mimeType });
  downloadFile(blob, name);
};

export default downloadFileFromTrpc;
